<template lang="pug">
.badgeSelectOptionComponent(
  @click="onClick",
  :class="[optionClasses, `_${variant}`]"
)
  span {{ option.label }}
  .icon(v-if="option.icon")
    ui-svg-icon(:name="option.icon")
</template>

<script>
export default {
  props: {
    option: {
      type: Object,
      default: null
    },
    // default | catalog
    variant: {
      type: String,
      default: 'default'
    },
    isSelected: Boolean,
    isDisabled: Boolean
  },
  emits: ['select', 'deselect'],
  computed: {
    optionClasses () {
      return {
        _selected: this.isSelected,
        _disabled: this.isDisabled
      }
    }
  },
  methods: {
    onClick () {
      if (!this.isDisabled) this.$emit(this.isSelected ? 'deselect' : 'select', this.option.value)
    }
  }
}
</script>

<style lang="sass" scoped>
.badgeSelectOptionComponent
  @include font('t16-medium')
  display: flex
  align-items: center
  justify-content: center
  @include gap(2.5*$u)
  border: 0.75*$u solid $cBlue
  border-radius: 4*$u
  padding: 1.7*$u 4*$u
  background-color: transparent
  transition: all $animationSpeed linear
  cursor: pointer

  > .icon
    color: $cBlue
    width: 4*$u
    height: 4*$u
    flex: 0 0 4*$u

  &:hover
    background-color: $cWhite
    box-shadow: 0 2*$u 4.5*$u rgba(37, 64, 142, 0.2)

  &._selected
    background-color: $cDarkBlue
    color: $cWhite
    border-color: $cDarkBlue

  &._catalog
    @include font('t14-medium')
    line-height: 5*$u
    padding: 2*$u 3*$u
    border: none
    background-color: $cWhite
    color: $cBlue

    &._selected
      background-color: $cDarkBlue
      color: $cWhite
      > .icon
        color: $cWhite
</style>
